const createVoucherDE = {
    key: 'Schlüssel',
    productId: 'Produkt-ID',
    variantId: 'Varianten-ID',
    licenseId: 'Lizenz-ID',
    maxSessions: 'Max. Verwendungen',
    generate: 'Schlüssel generieren'
}

export default createVoucherDE